import NetworkError from "./NetworkError";
import RequestError from "./RequestError";
import WebAPIError from "./WebAPIError";
import { showMessage, TOAST_TYPE } from 'common/alert'

export const ParseError = (error, show) => {
    if (show) showMessage({ message: error.message, type: TOAST_TYPE.ERROR });
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error);
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        //throw new TypeError('Expected an array but got an invalid argument');
        throw new WebAPIError(error);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(error)
        throw new NetworkError(error);
    } else {
        // Something happened in setting up the request that triggered an Error
        // console.log(error)
        // console.log('Error', error.message);
        throw new RequestError(error);
    }
}